import React, { useState } from "react";
import { projects } from "../mock";

const categories = ["Alle", "Particulier", "Zakelijk", "Werkproces"];

const Projects = () => {
  const [active, setActive] = useState("Alle");

  const filtered = active === "Alle" ? projects : projects.filter((p) => p.category === active);

  return (
    <section id="projecten" className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-100 text-slate-800 text-xs font-semibold mb-4 border border-yellow-200">
              Projecten
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 text-balance">
              Een greep uit ons spuitwerk
            </h2>
            <p className="mt-4 text-lg text-slate-600 leading-relaxed">
              Van strakke woonkamers tot complete bedrijfspanden. Bekijk een aantal
              recente klussen die we hebben opgeleverd.
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors border ${
                  active === c
                    ? "bg-slate-900 text-white border-slate-900"
                    : "bg-white text-slate-700 border-slate-200 hover:border-slate-300"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered.map((p) => (
            <div key={p.title} className="group relative rounded-2xl overflow-hidden bg-white shadow-sm ring-1 ring-slate-200 hover-lift">
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-bold text-slate-900">{p.title}</h3>
                  <span className="text-xs font-semibold px-2 py-1 rounded-full bg-yellow-100 text-slate-800 border border-yellow-200">
                    {p.category}
                  </span>
                </div>
                <div className="text-sm text-slate-500 mt-1">{p.location}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
